import { IFaireAcademyChapter } from "@faire/web-api--source/indigofair/data/IFaireAcademyChapter";
import { IFaireAcademyGuide } from "@faire/web-api--source/indigofair/data/IFaireAcademyGuide";

export type FaireAcademyGuide = {
  id: IFaireAcademyGuide.GuideIdentifier;
  title: string;
  description: string;
  cardSummary: string;
  guideSummary: React.ReactNode;
  featuredImage: string;
  featuredImageAltText: string;
  backgroundImage: string;
  readTimeMinutes: number;
  chapters: Array<FaireAcademyChapter>;
  linkToPage: string;
  titleTag: string;
  likes?: number;
};

export type FaireAcademyChapter = {
  id: IFaireAcademyChapter.ChapterIdentifier;
  title: string;
  readTimeMinutes: number;
  titleHash: string;
  ChapterComponent: React.ComponentType;
};

export enum OWF_GUIDE_SOURCE_NAME {
  GUIDES_LANDING_PAGE = "GUIDES_LANDING_PAGE",
  INDIVIDUAL_GUIDE_PAGE = "INDIVIDUAL_GUIDE_PAGE",
  GUIDES_DROPDOWN = "GUIDES_DROPDOWN",
  GUIDES_LANDING_PAGE_HEADER = "GUIDES_LANDING_PAGE_HEADER",
}
